import { TextGrey } from '../../../../../components/Basic/WrapsStyle';
import { MAP_SKLAD } from '../../../../../constans';
import { formFullDate } from '../../../../../utils';
import { getDate } from '../../../../../utils/index';

const defineAction = (part) => {
  console.log('part', part);
  if (part.action === 'pack') {
    return 'Заказ упакован';
  }
  if (part.action === 'sort') {
    return 'Заказ отсортирован';
  }
  if (part.action === 'pick') {
    return part.value ? 'Распечатал(а) этикетку' : 'Убрал(а) галку с печати этикетки';
  }

  console.log(part.action, part.field);
  if (part.action === 'change') {
    if (part.field === 'status') {
      return `Изменен статус заказа:  ${part.value}`;
    }
    if (part.field === 'shipment_diff') {
      return `Изменен статус расхождения для артикула ${part.offer_id} на:  ${part.value || ''}`;
    }
    if (part.field === 'variance_status') {
      if (!part.value) {
        return `Убран статус оформления расхождения для артикула ${part.offer_id}`;
      }
      return `Изменен статус оформления расхождения для артикула ${part.offer_id} на:  ${part.value || ''}`;
    }
    if (part.field === 'dokup_status') {
      if (!part.value) {
        return `Убран статус докупа для артикула ${part.offer_id}`;
      }
      return `Изменен статус докупа для артикула ${part.offer_id} на:  ${part.value || ''}`;
    }
    if (part.field === 'dokup_date') {
      if (!part.value) {
        return `Убран статус докупа для артикула ${part.offer_id}`;
      }
      return `Изменена дата докупа для артикула ${part.offer_id} на:  ${getDate(part.value) || ''}`;
    }
    if (part.field === 'checkup_response_msg') {
      if (!part.value) {
        return `Убран ответ для проверки`;
      }
      return `Изменен ответ для проверки на:  ${part.value}`;
    }
    if (part.field === 'penalty') {
      return `Выставлен штраф`;
    }
    if (part.field === 'skladName') {
      return `Изменен склад отгрузки на: ${MAP_SKLAD[part.value]}`;
    }
    if (part.field === 'variance_return') {
      if (!part.value) {
        return `Убран статус возврата для артикула ${part.offer_id}`;
      }
      return `Изменен статус возврата товара для артикула ${part.offer_id} на: ${part.value}`;
    }
    if (part.field === 'variance_upd') {
      if (!part.value) {
        return `Убран номер упд для артикула ${part.offer_id}`;
      }
      return `Изменен номер упд для артикула ${part.offer_id} на: ${part.value}`;
    }

  }
};

const HistoryBase = ({ part, ...props }) => {
  return (
    <>
      <td>
        {' '}
        <TextGrey>{formFullDate(part.date)}</TextGrey>
      </td>

      <td>
        <b>{part.user}</b>
      </td>

      <td> {defineAction(part)}</td>
    </>
  );
};

export default HistoryBase;
